import {createSelector} from 'reselect';
import {getYearData} from '../year';
import {IYear} from '../../../data/data';


export const getMapWweatherState = createSelector(

    [getYearData],

    (year_data: IYear) : string =>
    {
        return year_data['map-state'] === 'snow' ? 'snow' : 'normal';
    }
);



// WEBPACK FOOTER //
// ./src/ts/store/reducers/map/mapState.ts